import React, { useEffect, useState } from 'react'
import { graphql } from 'gatsby'
import GraphQLErrorList from '../../components/graphql-error-list'
import SEO from '../../components/seo'
import Layout from '../../containers/layout'
import * as styles from '../../components/globals-v2.module.css'
import * as start from './../content-hub/start.module.css'
import Category from '../../components/hub/category/category'
import Search from '../../components/hub/search/search'
import Card from '../../components/hub/card/card'
import Container from '../../components/container'
import * as linkStyle from '../../styles/components/links.module.css'

export const query = graphql`
    query BestOfSocialsQuery {
        page: sanityPage(title: { eq: "Best of Socials" }) {
            title
            _rawBody
            metaTitle
            metaDescription
            metaKeywords
        },
        short: allSanityShort(sort: {order: DESC, fields: publishedAt}) {
            nodes {
                url
                title
                platform
                featureImage:
                image {
                    asset {
                        _id
                        url
                    }
                    hotspot {
                        _key
                        _type
                        x
                        y
                        height
                        width
                    }
                }
            }
        },
        tags: allSanityTag(filter: { display: { ne: false } }) {
            nodes {
                display
                title
                position
                slug {
                    current
                }
            }
        }
    }
`

const BestOfSocialsPage = props => {
  const {
    data,
    errors
  } = props

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }

  const page = data.page
  if (!page) {
    throw new Error(
      'Missing "Best of Socials" page data. Open the studio at http://localhost:3333 and add "Best of Socials" page data and restart the development server.'
    )
  }

  const perPage = 12

  const [allPosts, setAllPosts] = useState([])
  const [results, setResults] = useState([])
  const [resultCount, setResultCount] = useState(perPage)

  useEffect(() => {
    const allPosts = data?.short?.nodes
    if (!allPosts.length) return

    setAllPosts(allPosts)
    setResults(allPosts.slice(0, resultCount))
  }, [resultCount, query, data])

  return (
    <Layout palette='red' hideContactBar>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <SEO
        title={page.metaTitle || page.title || 'No title'} description={page.metaDescription}
        keywords={page.metaKeywords}
      />

      <Container size='large' class={`${styles.container} ${styles.contentHubContainer}`}>
        <section className={start.menuWtSearch}>
          <Category nodes={data.tags.nodes} type='category' current='all' />
          <Search />
        </section>

        <div className={`${styles.bestOfSocialTitle} ${styles.bestOfSocialTitleLarge}`}><span>Best of Socials</span></div>
        <div className={start.bestOfSocialGrid}>
          {results !== null && (
            results.map((social, index) => (
              <Card page='content-hub' key={index} options={{ whiteIcon: true, followBtn: false }} type='social' section='chSocial' data={social} />
            ))
          )}
        </div>
        {(resultCount < allPosts?.length) && (
          <div className={start.moreButton}>
            <a className={`${linkStyle.linkPlus} ${linkStyle.white}`} onClick={() => setResultCount(resultCount + perPage)}>More
              <span>
                <div className={linkStyle.iconPlus} />
              </span>
            </a>
          </div>
        )}
      </Container>

    </Layout>
  )
}

export default BestOfSocialsPage
